import { TracksListContext } from "./TracksListContext";
import { tracksListStore } from "./TrackslistStore";


export const TracksListProvider = ({ children }) => {
  return (
    <TracksListContext value={tracksListStore}>
      {children}
    </TracksListContext>
  )
};
